export default "__VITE_ASSET__CGX2zcVJ__"